import { render, staticRenderFns } from "./BusinessActivityChart.vue?vue&type=template&id=665a7344&"
import script from "./BusinessActivityChart.vue?vue&type=script&lang=js&"
export * from "./BusinessActivityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports